<template>
  <component :is="tag">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'KfHeading',
  props: {
    tag: {
      type: [String],
      required: true,
    },
  },
};
</script>
